import { OutputDateRange } from "src/features/PageConfigProvider/types/OutputDateRange";

export enum FilterFieldsKeys {
  CreationTime = "creationTime",
  LastModifiedTime = "lastModifiedTime",
  ChainName = "chainName",
  BatchId = "batchId",
  AssetName = "assetName",
  SpenderAddress = "spenderAddress",
  Status = "status",
  Statuses = "statuses",
}

export type FilterFields = {
  [FilterFieldsKeys.CreationTime]: OutputDateRange;
  [FilterFieldsKeys.LastModifiedTime]: OutputDateRange;
  [FilterFieldsKeys.ChainName]: string;
  [FilterFieldsKeys.BatchId]: string;
  [FilterFieldsKeys.AssetName]: string;
  [FilterFieldsKeys.SpenderAddress]: string;
  [FilterFieldsKeys.Statuses]: string[];
};
